// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"abbcfc46","111":"e56f65a5","323":"e56f65a5","429":"abbcfc46","535":"abbcfc46","642":"abbcfc46","998":"e56f65a5"}[chunkId] + ".chunk.css";
};